import React from 'react';
import styles from './BlobDecoration.module.css';

interface BlobDecorationProps {
  color: 'red' | 'green' | 'blue' | 'yellow';
  position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const BlobDecoration: React.FC<BlobDecorationProps> = ({
  color,
  position,
  size = 'md',
  className = '',
}) => {
  return (
    <div
      className={`${styles.blob} ${styles[color]} ${styles[position]} ${styles[size]} ${className}`}
      aria-hidden="true"
    />
  );
};

export default BlobDecoration;
